var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subtitle subtitle-typed",class:{ typing: _vm.typeStatus }},[_vm._v(" "+_vm._s(_vm.typeValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }